import { useState as C, useMemo as I } from "react";
import { SortOrder as r } from "../components/responsive-table/roche-responsive-table.types.js";
const g = (a) => {
  const [e, E] = C(null), [s, m] = C(r.DESCENDING);
  return { sortedData: I(() => e === null ? a : [...a].sort((n, u) => {
    const t = n.body[e], o = u.body[e], N = ((t == null ? void 0 : t.sortValue) ?? (typeof (t == null ? void 0 : t.value) == "string" ? t.value : "")).toLowerCase(), S = ((o == null ? void 0 : o.sortValue) ?? (typeof (o == null ? void 0 : o.value) == "string" ? o.value : "")).toLowerCase();
    if (N === S) return 0;
    const D = parseFloat(N.replace(",", ".")), c = parseFloat(S.replace(",", "."));
    if (!Number.isNaN(D) && !Number.isNaN(c))
      return s === r.ASCENDING ? D - c : c - D;
    const p = N > S ? 1 : -1;
    return s === r.ASCENDING ? p : -p;
  }), [a, e, s]), sortByIndex: e, sortDirection: s, toggleSort: (n) => {
    e === n ? m((u) => u === r.ASCENDING ? r.DESCENDING : r.ASCENDING) : (E(n), m(r.ASCENDING));
  } };
};
export {
  g as useTableSort
};
